module.exports = __webpack_public_path__ + "img/cranberry-pumpkin-bread.f4d1de7d.jpg";